export default function CopilotIcon(
  props: Pick<React.SVGProps<SVGSVGElement>, "className">,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="22"
      viewBox="0 0 24 22"
      fill="none"
      className={props.className}
    >
      <path
        d="M17.4914 1.96705C17.3387 1.44724 17.0217 0.99085 16.588 0.666188C16.1543 0.341526 15.6271 0.166049 15.0853 0.166016H14.3541C13.7675 0.166003 13.1994 0.371615 12.7487 0.747088C12.298 1.12256 11.9932 1.64414 11.8873 2.22109L10.6328 9.05312L10.9443 7.98874C11.0965 7.46825 11.4134 7.01113 11.8474 6.68593C12.2814 6.36073 12.8091 6.18497 13.3514 6.185H17.6051L19.3894 6.87941L21.1092 6.18446H20.6076C20.0657 6.18454 19.5384 6.00912 19.1045 5.68445C18.6707 5.35978 18.3537 4.90333 18.201 4.38342L17.4914 1.96705Z"
        fill="url(#paint0_radial_19918_25370)"
      />
      <path
        d="M6.75855 20.0211C6.90958 20.5435 7.22629 21.0026 7.66095 21.3293C8.09561 21.656 8.62467 21.8326 9.16842 21.8325H10.723C11.3769 21.8325 12.005 21.5772 12.4734 21.1208C12.9418 20.6645 13.2134 20.0433 13.2304 19.3895L13.3994 12.8013L13.0451 14.0108C12.8928 14.5311 12.5759 14.988 12.1421 15.3131C11.7082 15.6382 11.1807 15.814 10.6385 15.814H6.34905L4.81993 14.9842L3.16406 15.814H3.65806C4.20163 15.8141 4.73044 15.9908 5.16489 16.3175C5.59933 16.6442 5.91587 17.1032 6.06685 17.6253L6.75964 20.0211H6.75855Z"
        fill="url(#paint1_radial_19918_25370)"
      />
      <path
        d="M14.978 0.166016H6.2897C3.80724 0.166016 2.31821 3.44688 1.32533 6.72721C0.148837 10.6147 -1.39112 15.812 3.063 15.812H6.81403C7.3594 15.8125 7.89007 15.6352 8.32562 15.307C8.76117 14.9788 9.07786 14.5175 9.22769 13.9931C10.1119 10.8917 11.0095 7.79403 11.9203 4.7003C12.3769 3.16034 12.7566 1.83814 13.34 1.01426C13.6672 0.552765 14.2121 0.166016 14.978 0.166016Z"
        fill="url(#paint2_linear_19918_25370)"
      />
      <path
        d="M14.978 0.166016H6.2897C3.80724 0.166016 2.31821 3.44688 1.32533 6.72721C0.148837 10.6147 -1.39112 15.812 3.063 15.812H6.81403C7.3594 15.8125 7.89007 15.6352 8.32562 15.307C8.76117 14.9788 9.07786 14.5175 9.22769 13.9931C10.1119 10.8917 11.0095 7.79403 11.9203 4.7003C12.3769 3.16034 12.7566 1.83814 13.34 1.01426C13.6672 0.552765 14.2121 0.166016 14.978 0.166016Z"
        fill="url(#paint3_linear_19918_25370)"
      />
      <path
        d="M9.01953 21.8323H17.7078C20.1898 21.8323 21.6793 18.5509 22.6722 15.27C23.8482 11.3825 25.3876 6.18359 20.9345 6.18359H17.183C16.6377 6.18322 16.1071 6.36058 15.6717 6.6888C15.2363 7.01701 14.9197 7.47821 14.7699 8.00251C13.8854 11.1047 12.9877 14.203 12.0767 17.2975C11.6206 18.8374 11.2404 20.1602 10.6575 20.9841C10.3304 21.4456 9.78545 21.8323 9.01953 21.8323Z"
        fill="url(#paint4_radial_19918_25370)"
      />
      <path
        d="M9.01953 21.8323H17.7078C20.1898 21.8323 21.6793 18.5509 22.6722 15.27C23.8482 11.3825 25.3876 6.18359 20.9345 6.18359H17.183C16.6377 6.18322 16.1071 6.36058 15.6717 6.6888C15.2363 7.01701 14.9197 7.47821 14.7699 8.00251C13.8854 11.1047 12.9877 14.203 12.0767 17.2975C11.6206 18.8374 11.2404 20.1602 10.6575 20.9841C10.3304 21.4456 9.78545 21.8323 9.01953 21.8323Z"
        fill="url(#paint5_linear_19918_25370)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_19918_25370"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(19.5838 9.11108) rotate(-129.304) scale(9.37259 8.81322)"
        >
          <stop offset="0.096" stopColor="#00AEFF" />
          <stop offset="0.773" stopColor="#2253CE" />
          <stop offset="1" stopColor="#0736C4" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_19918_25370"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(5.02056 15.7749) rotate(51.84) scale(8.66188 8.40226)"
        >
          <stop stopColor="#FFB657" />
          <stop offset="0.634" stopColor="#FF5F3D" />
          <stop offset="0.923" stopColor="#C02B3C" />
        </radialGradient>
        <linearGradient
          id="paint2_linear_19918_25370"
          x1="5.7697"
          y1="2.06184"
          x2="7.00903"
          y2="16.4024"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.156" stopColor="#0D91E1" />
          <stop offset="0.487" stopColor="#52B471" />
          <stop offset="0.652" stopColor="#98BD42" />
          <stop offset="0.937" stopColor="#FFC800" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_19918_25370"
          x1="6.85303"
          y1="0.166016"
          x2="7.53011"
          y2="15.812"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3DCBFF" />
          <stop offset="0.247" stopColor="#0588F7" stopOpacity="0" />
        </linearGradient>
        <radialGradient
          id="paint4_radial_19918_25370"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(21.3802 4.65128) rotate(109.274) scale(20.7931 24.9094)"
        >
          <stop offset="0.066" stopColor="#8C48FF" />
          <stop offset="0.5" stopColor="#F2598A" />
          <stop offset="0.896" stopColor="#FFB152" />
        </radialGradient>
        <linearGradient
          id="paint5_linear_19918_25370"
          x1="22.0672"
          y1="5.2281"
          x2="22.058"
          y2="9.49046"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.058" stopColor="#F8ADFA" />
          <stop offset="0.708" stopColor="#A86EDD" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
